import { useTranslation } from 'react-i18next';
import { message, ModalFormActions, RichTextEditor, Title } from 'ui';
import { useAcceptConsents } from '../../../queries';
import { type Consent } from '../../../types';
import { ContinueReading } from './ContinueReading';

type P = {
  consent: Consent;
  onAccept: () => void;
  onCancel: () => void;
};

const ConsentDetail = ({ consent, onAccept, onCancel }: P) => {
  const { t } = useTranslation();
  const { mutate: acceptConsents, isLoading: isAcceptingConsents } = useAcceptConsents();

  const acceptConsent = () => {
    acceptConsents(
      { consentIds: [consent.id] },
      {
        onSuccess() {
          onAccept();
        },
        onError() {
          message.error(t('Failed to confirm consent: {{name}}', { name: consent.name }));
        },
      },
    );
  };

  return (
    <div className="consent-detail">
      <Title level={2}>{consent.name}</Title>
      <div className="consent-detail__content">
        <RichTextEditor editable={false} data={consent.htmlContent} />
        {consent.consented ? null : <ContinueReading />}
      </div>
      <ModalFormActions
        right={{ onClick: onCancel, children: 'Back' }}
        submit={
          consent.consented ? undefined : { onClick: acceptConsent, children: 'Confirm', loading: isAcceptingConsents }
        }
      />
    </div>
  );
};

export default ConsentDetail;
